import { MediaStateResponse } from './media-state.types'

const storageKey = 'media-state-cache'

export const readMediaStateCache = (): MediaStateResponse | null => {
  const cached = sessionStorage.getItem(storageKey)
  if (!cached) return null
  try {
    const parsed = JSON.parse(cached) as MediaStateResponse
    if (!parsed || typeof parsed !== 'object') return null
    return {
      favorites: parsed.favorites ?? [],
      watchlist: parsed.watchlist ?? [],
      history: parsed.history ?? [],
      stats: parsed.stats,
    }
  } catch {
    return null
  }
}

export const writeMediaStateCache = (state: MediaStateResponse | null) => {
  if (!state) {
    sessionStorage.removeItem(storageKey)
    return
  }
  sessionStorage.setItem(storageKey, JSON.stringify(state))
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  readMediaStateCache,
  writeMediaStateCache,
}
